import { Helmet } from "react-helmet-async";
import { canonicalUrl } from "@/lib/canonicalUrl";

interface SEOProps {
  title: string;
  description: string;
  path?: string;
  noindex?: boolean;
}

/**
 * Per-route SEO tags. Title <60 chars, description <160 chars.
 * Pass `path` (e.g. "/pricing") to set canonical + og:url.
 */
export function SEO({ title, description, path, noindex }: SEOProps) {
  const url = path ? canonicalUrl(path) : undefined;
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      {url && <link rel="canonical" href={url} />}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      {url && <meta property="og:url" content={url} />}
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      {noindex && <meta name="robots" content="noindex,nofollow" />}
    </Helmet>
  );
}
